/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/** Arguments for sending a dynamic scenario to the simulator */
export interface SendDynamicScenarioActionArgs {
  /** JSON-encoded string of scenario */
  scenarioJson: string;
  /** If true, replaces all already-existing actors in the scene */
  replaceExisting: boolean;
}

export interface SendDynamicScenarioResultData {
}

export interface SendDynamicScenarioActionStateData {
}

function createBaseSendDynamicScenarioActionArgs(): SendDynamicScenarioActionArgs {
  return { scenarioJson: "", replaceExisting: false };
}

export const SendDynamicScenarioActionArgs = {
  encode(message: SendDynamicScenarioActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.scenarioJson !== "") {
      writer.uint32(10).string(message.scenarioJson);
    }
    if (message.replaceExisting === true) {
      writer.uint32(16).bool(message.replaceExisting);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendDynamicScenarioActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendDynamicScenarioActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.scenarioJson = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.replaceExisting = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendDynamicScenarioActionArgs {
    return {
      scenarioJson: isSet(object.scenarioJson) ? globalThis.String(object.scenarioJson) : "",
      replaceExisting: isSet(object.replaceExisting) ? globalThis.Boolean(object.replaceExisting) : false,
    };
  },

  toJSON(message: SendDynamicScenarioActionArgs): unknown {
    const obj: any = {};
    if (message.scenarioJson !== "") {
      obj.scenarioJson = message.scenarioJson;
    }
    if (message.replaceExisting === true) {
      obj.replaceExisting = message.replaceExisting;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendDynamicScenarioActionArgs>, I>>(base?: I): SendDynamicScenarioActionArgs {
    return SendDynamicScenarioActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendDynamicScenarioActionArgs>, I>>(
    object: I,
  ): SendDynamicScenarioActionArgs {
    const message = createBaseSendDynamicScenarioActionArgs();
    message.scenarioJson = object.scenarioJson ?? "";
    message.replaceExisting = object.replaceExisting ?? false;
    return message;
  },
};

function createBaseSendDynamicScenarioResultData(): SendDynamicScenarioResultData {
  return {};
}

export const SendDynamicScenarioResultData = {
  encode(_: SendDynamicScenarioResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendDynamicScenarioResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendDynamicScenarioResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SendDynamicScenarioResultData {
    return {};
  },

  toJSON(_: SendDynamicScenarioResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SendDynamicScenarioResultData>, I>>(base?: I): SendDynamicScenarioResultData {
    return SendDynamicScenarioResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendDynamicScenarioResultData>, I>>(_: I): SendDynamicScenarioResultData {
    const message = createBaseSendDynamicScenarioResultData();
    return message;
  },
};

function createBaseSendDynamicScenarioActionStateData(): SendDynamicScenarioActionStateData {
  return {};
}

export const SendDynamicScenarioActionStateData = {
  encode(_: SendDynamicScenarioActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendDynamicScenarioActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendDynamicScenarioActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SendDynamicScenarioActionStateData {
    return {};
  },

  toJSON(_: SendDynamicScenarioActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SendDynamicScenarioActionStateData>, I>>(
    base?: I,
  ): SendDynamicScenarioActionStateData {
    return SendDynamicScenarioActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendDynamicScenarioActionStateData>, I>>(
    _: I,
  ): SendDynamicScenarioActionStateData {
    const message = createBaseSendDynamicScenarioActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
